import { PDF_COLORS, pdfFz } from "./stylesPDFv2";

/**
 * Aviso / nota al pie de una sección: un panel de fondo suave, sin bordes, para
 * leyendas que el lector NO debe pasar por alto (marcas con asterisco, avisos de
 * vista previa, advertencias de captura). Devuelve {} si no hay líneas, para
 * poder insertarlo siempre en el content sin condicional adicional.
 *
 * @param {object} params
 * @param {Array<string|object>} params.lineas texto o nodos pdfMake ya armados
 * @param {string} params.fillColor fondo del panel (por defecto el tono de marca)
 * @param {Array<number>} params.margin margen del nodo
 * @returns nodo pdfMake
 */
export const PDFAvisoV2 = ({ lineas = [], fillColor = PDF_COLORS.tint, margin = [0, 6, 0, 0] } = {}) => {
  const filas = (lineas || []).filter(Boolean);
  if (filas.length === 0) return {};

  return {
    margin,
    table: {
      widths: ["*"],
      body: [
        [
          {
            border: [false, false, false, false],
            fillColor,
            margin: [8, 6, 8, 6],
            stack: filas.map((linea, i) => {
              const base = {
                fontSize: pdfFz(6.5),
                color: PDF_COLORS.ink,
                margin: [0, i === 0 ? 0 : 2, 0, 0],
              };
              return typeof linea === "string" ? { ...base, text: linea } : { ...base, ...linea };
            }),
          },
        ],
      ],
    },
    layout: "noBorders",
  };
};

export default PDFAvisoV2;
